exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-dialog__header {\r\n  border-bottom: 1px solid #fff;\r\n  padding-bottom: 0 !important;\n}\r\n", ""]);

// exports
